import { Routes } from '@angular/router';
import { AppRoutingPathsEnum } from '@/shared/config/app-routing-paths.enum';
import { authGuard } from '@/shared/guards/auth.guard';

export const APP_ROUTES: Routes = [
  {
    path: AppRoutingPathsEnum.Desktop,
    canActivate: [authGuard],
    loadChildren: (): any => import('@/app/routes/main.routes').then(m => m.MAIN_ROUTES),
  },
  {
    path: '**',
    redirectTo: AppRoutingPathsEnum.Desktop,
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: AppRoutingPathsEnum.Desktop,
  },
];
